export default __webpack_public_path__ + "1161206c8ab903d12c57b880c514e595.png";